import React from 'react';
import CloseModal from './CloseModal';
import NoRecords from './NoRecords';
import { formatDate, formatDateOnly } from '../Constants/constant';

const CandidateStatusHistory = ({loading, onClose, data}) => {
    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[80vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
                <CloseModal disabled={loading} onClick={onClose} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Candidate Status History</h1>
                {data?.length >= 1 ?
                <div className='tableWrapper'>
                    <div className='tableBody'>
                        <table className='w-full table-fixed border-collapse'>
                            <thead className='tableHead'>
                                <tr className=' text-left'>
                                    <th className=' w-[5%] text-center'>Sr. No.</th>
                                    <th className='w-[20%] whitespace-nowrap'>Candidate status</th>
                                    <th className='w-[15%] whitespace-nowrap text-center'>Updated at date</th>
                                    <th className='w-[15%] whitespace-nowrap text-center'>Sent email count</th>
                                    <th className=''>Remark</th>
                                    <th className='w-[15%] whitespace-nowrap'>Action By</th>
                                </tr>
                            </thead>
                            <tbody className='tableBody  '>
                                {
                                    data?.map((val, idx) => {
                                        return (
                                            <tr className=' text-left'>
                                                <td className=' text-center'>{idx + 1}</td>
                                                <td>{val?.candidate_status}</td>
                                                <td className=' text-center'>{val?.status_date?.includes(':') ? formatDate(val?.status_date) : formatDateOnly(val?.status_date) }</td>
                                                <td className=' text-center'>{val?.sent_email_count?.toString()?.padStart(2,0) || "--"}</td>
                                                <td className=' text-wrap'>{val?.status_remarks || "--"}</td>
                                                <td>{val?.action_by_name?.name || "--"}</td>
                                            </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>
                    </div>
                </div> :
                <NoRecords/>}
            </div>
        </div>
    );
}

export default CandidateStatusHistory;
